import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

type GridLayoutFourIconProps = IconClientSVGProps & {
  filled?: boolean;
};

export const GridLayoutFourIcon = forwardRef<
  SVGSVGElement,
  GridLayoutFourIconProps
>(({ filled, label, ...props }, ref) => {
  return (
    <Icon label={label}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        ref={ref}
        {...props}
      >
        {filled ? (
          <>
            <path d="M2 11H8V18H2V11Z" fill="currentColor" />
            <path d="M10 11H13V18H10V11Z" fill="currentColor" />
            <path d="M15 11H18V18H15V11Z" fill="currentColor" />
            <path d="M2 2H5V9H2V2Z" fill="currentColor" />
            <path d="M7 2H10V9H7V2Z" fill="currentColor" />
            <path d="M12 2H18V9H12V2Z" fill="currentColor" />
            <path d="M2 11H8V18H2V11Z" stroke="currentColor" />
            <path d="M10 11H13V18H10V11Z" stroke="currentColor" />
            <path d="M15 11H18V18H15V11Z" stroke="currentColor" />
            <path d="M2 2H5V9H2V2Z" stroke="currentColor" />
            <path d="M7 2H10V9H7V2Z" stroke="currentColor" />
            <path d="M12 2H18V9H12V2Z" stroke="currentColor" />
          </>
        ) : (
          <>
            <path d="M2 11H8V18H2V11Z" stroke="currentColor" />
            <path d="M10 11H13V18H10V11Z" stroke="currentColor" />
            <path d="M15 11H18V18H15V11Z" stroke="currentColor" />
            <path d="M2 2H5V9H2V2Z" stroke="currentColor" />
            <path d="M7 2H10V9H7V2Z" stroke="currentColor" />
            <path d="M12 2H18V9H12V2Z" stroke="currentColor" />
          </>
        )}
      </svg>
    </Icon>
  );
});

GridLayoutFourIcon.displayName = "GridLayoutFourIcon";
